// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./add.scss');

const deps = [
  require('angular-ui-router'),
  require('data/collection/categorizerRule').name,
  require('ui/web/confirmDialog').name,
];

module.exports = angular
  .module('bench.ui.categorizerNavbar.add', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.categorizer.add', {
      url: '',
      onEnter($state, _rules, ngDialog) {
        this.rulesId = _rules.$storeId();

        return ngDialog
          .open({
            appendTo: '[ng-app]',
            template: `\
<div class="add-rule-card">
  <div
    class="bl-card_section bl-card_section-padded-medium add-rule-card_header">
    <a ui-sref="bench.categorizer" class="bl-icon-close add-rule-card_close"></a>
  </div>
  <bl-categorizer-rule-input rules-id="${this.rulesId}"></bl-categorizer-rule-input>
</div>\
`,
          })
          .closePromise.then(() => $state.go('bench.categorizer'));
      },
      onExit(ngDialog) {
        return ngDialog.closeAll();
      },
    }),
  );
